import { readStorageConsent } from "@/lib/cookie-consent";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { fr } from "./locales/fr";
import { en } from "./locales/en";
import { es } from "./locales/es";

export const SUPPORTED_LANGS = ["fr", "en", "es"] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export const LANG_LABELS: Record<SupportedLang, string> = {
  fr: "Français",
  en: "English",
  es: "Español",
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    lng: import.meta.env.VITE_DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LANGS],
    interpolation: { escapeValue: false },
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
    },
    detection: {
      order: readStorageConsent()?.preferences
        ? ["localStorage", "navigator", "htmlTag"]
        : ["navigator", "htmlTag"],
      caches: [],
    },
  });

export { i18n };

i18n.on("languageChanged", (language) => {
  document.documentElement.lang = language.split("-")[0] ?? "fr";
  if (readStorageConsent()?.preferences) {
    try {
      localStorage.setItem("i18nextLng", language);
    } catch {
      /* stockage indisponible */
    }
  }
});
